import * as React from 'react';
import Box from '@mui/material/Box';
import { LinearProgress } from '@mui/material';

function LoadingSkeleton() {
  return (
    <Box
      sx={{
        height: 'max-content',
        background: '#ffffff',
        borderBottom: '1px solid #DCDFE3'
      }}
    >
      <Box sx={{ height: 'max-content' }}>
        <LinearProgress />
      </Box>
    </Box>
  );
}

export default LoadingSkeleton;
